import { INotifyTemplateApiCall, IRenderTemplate, IRestApiService, NotifyTemplate } from '../types';

class NotifyTemplateApiCall implements INotifyTemplateApiCall {
  private restApiService: IRestApiService;

  constructor(restApiService: IRestApiService) {
    this.restApiService = restApiService;
  }

  getTemplate(name: string): Promise<NotifyTemplate> {
    return this.restApiService.get(`notify-template/${name}`);
  }

  updateTemplate(name: string, template: string): Promise<NotifyTemplate> {
    return this.restApiService.post(`notify-template/`, {
      name,
      template
    });
  }

  renderTemplate(name: string, template: any): Promise<IRenderTemplate> {
    return this.restApiService.post(`notify-template/render/`, { name, template });
  }
}

export default NotifyTemplateApiCall;
